module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/interesados.1c6dac85.svg";